module.exports = __webpack_public_path__ + "static/media/SF-1.068dff9c.mp3";